module.exports = __webpack_public_path__ + "img/icon_refresh_reload.e431ecd0.svg";